import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { failPageIcon, successPageIcon } from '../../constants';
import { Text18 } from '../../ui/Text18';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const Content = styled.div`
  width: 90%;
  max-width: 1400px;
  min-width: 320px;
  margin-top: 200px;
  display: flex;
  align-items: center;
  text-align: center;

  @media (max-width: 1035px) {
    flex-direction: column-reverse;
  }
`;

const ImageWrapper = styled.div`
  @media (max-width: 1035px) {
    margin-top: 50px;
  }
`;

const Image = styled.img`
  height: 500px;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const InfoTitle = styled.h1`
  margin-bottom: 50px;
`;

const InfoDesc = styled(Text18)``;

const ButtonWrapper = styled.div`
  margin-top: 48px;
  width: 395px;
`;

const FailPage: React.FC<{}> = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Content>
        <ImageWrapper>
          <Image src={failPageIcon} />
        </ImageWrapper>
        <InfoWrapper>
          <InfoTitle>{t('fail_title')}</InfoTitle>
          <InfoDesc>{t('fail_desc')}</InfoDesc>
          <ButtonWrapper>
            <Button variant='contained'>
              <Text18>{t('fail_button')}</Text18>
            </Button>
          </ButtonWrapper>
        </InfoWrapper>
      </Content>
    </Wrapper>
  );
};

export default FailPage;
